module.exports = __webpack_public_path__ + "img/content11.177e298f.jpg";